  <div class="close-outer">
    <img src="assets/icons/close-x.png" class="close-btn" (click)="closeModal()">
  </div>
  
  <div class="videoContainer">
    <iframe frameborder="0" allowfullscreen allow="autoplay;" [src]="videoLink">
    </iframe>
  </div>
  